<script>
export default {
    mounted() {
        const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
        const recognition = new SpeechRecognition();
        recognition.lang = 'pt-BR';
        recognition.interimResults = true;
        recognition.maxAlternatives = 1;
        recognition.continuous = true;


        recognition.onstart = (evt) => {
            console.log('Recognition Started', {evt: evt});
        }

        recognition.onend = () => {
            console.log('Recognition Stopped')
        }

        recognition.onresult = (evt) => {
            const t = Array.from(evt.results)
                .map(result => result[0])
                .map(result => result.transcript)
                .join('')
            
            this.transcript = t;
            if (this.isPlaying) {
                Bus.$emit('selliaTranscript', this.transcript);
            }
        }

        this.recognition = recognition;
    },

    data() {
        return {
            transcript: "",
            recognition: null,
            isPlaying: false,
            audioDuration: 0,
            audioDurationInterval: null,
        }
    },

    computed: {
        getMinutesAndSecondsByDuration() {
            const minutes = Math.floor(this.audioDuration / 60);
            const seconds = this.audioDuration % 60;
            return `${minutes < 10 ? '0' + minutes : minutes}:${seconds < 10 ? '0' + seconds : seconds}`;
        }
    },

    methods: {
        startRecognition() {
            this.isPlaying = true;
            this.audioDurationInterval = setInterval(() => {
                this.audioDuration++;
            }, 1000);
            this.transcript = " ";
            if (this.recognition) {
                this.recognition.start();
            }
        },

        stopRecognition() {
            this.isPlaying = false;
            clearInterval(this.audioDurationInterval);
            // Emitir evento de finalização da transcrição
            Bus.$emit('selliaTranscriptEnd');
            
            this.transcript = "";
            if (this.recognition) {
                this.recognition.stop();
            }
        }, 

        deleteTranscript() {
            this.transcript = "";
            Bus.$emit('selliaTranscript', "");
            Bus.$emit('selliaTranscriptEnd');
        },
    },
}

</script>

<template>
    <div class="base-sellia-button bg-custom-light-blue rounded-pill px-2-5 py-1 d-flex align-items-center justify-content-center gap-1">
        <button class="button-icon-color rounded-circle border-0 p-1-5 d-flex align-items-center justify-content-center" @click="startRecognition">
            <IconPlayFilled color="#F4F1FF"/>
        </button>
        <button class="button-icon-color rounded-circle border-0 p-1-5 d-flex align-items-center justify-content-center" @click="stopRecognition">
            <IconPause color="#F4F1FF" size="5" />
        </button>
        <span class="text-custom-gray fw-500 fs-9 lt-1">
            {{ getMinutesAndSecondsByDuration }}
        </span>
        <div class="music mx-1-5 gap-0-5">
            <div class="dot" :class="{'line': isPlaying}"></div>
            <div class="dot" :class="{'line': isPlaying}"></div>
            <div class="dot" :class="{'line': isPlaying}"></div>
            <div class="dot" :class="{'line': isPlaying}"></div>
            <div class="dot" :class="{'line': isPlaying}"></div>
            <div class="dot" :class="{'line': isPlaying}"></div>
            <div class="dot" :class="{'line': isPlaying}"></div>
            <div class="dot" :class="{'line': isPlaying}"></div>
        </div>
        <button class="button-icon-color rounded-circle border-0 p-1-5 d-flex align-items-center justify-content-center" @click="deleteTranscript">
            <IconThinTrashCan color="#F4F1FF" size="9"/>
        </button>
    </div>
</template>

<style>
.p-1-5 {
    padding: 6px;
}

.gap-0-5 {
    gap: 2px;
}

.mx-1-5 {
    margin-left: 6px;
    margin-right: 6px;
}

.lt-1 {
    letter-spacing: 1px;
}

.fw-500 {
    font-weight: 500;
}

.fs-9 {
    font-size: 9px;
}


.text-custom-gray {
    color: #A6A3AB;
}

.button-icon-color {
    background-color: #5061F2;
}

.button-icon-color:hover {
    background-color: #F4F1FF;
}

.button-icon-color:hover .play-filled path {
    fill: #8869fd;
}

.button-icon-color:hover .pause path {
    fill: #8869fd;
}

.button-icon-color:hover .trash-can path {
    fill: #8869fd;
}

.bg-custom-light-blue {
    background-color: #E1E4FF;
}

.music {
    width: 100%;
    height: 20px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.music .dot {
    width: 2px;
    height: 3px;
    border-radius: 50px;
    background-color: #5061F2;
}

.music .line {
    animation: wave 1.5s ease-in-out infinite;
}

@keyframes wave {
    0%, 100% {
        height: 3px;
    }

    50% {
        height: 10px;
    }
}

.music .line:nth-child(1) {
    animation-delay: 6s;
}
.music .line:nth-child(2) {
    animation-delay: 4s;
}
.music .line:nth-child(3) {
    animation-delay: 2s;
}
.music .line:nth-child(4) {
    animation-delay: 1s;
}
.music .line:nth-child(5) {
    animation-delay: 1s;
}
.music .line:nth-child(6) {
    animation-delay: 2s;
}
.music .line:nth-child(7) {
    animation-delay: 4s;
}
.music .line:nth-child(8) {
    animation-delay: 6s;
}
</style>